import React from 'react';

const FindUs = () => (
  <div>
    <div className="app__bg" style={{ padding: '2rem'}}>
    </div>
  </div>
);

export default FindUs;
